var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "145.944,179.757 150.181,192.796 163.888,192.796 152.799,200.852 157.035,213.889  145.944,205.832 134.853,213.889 139.09,200.852 128,192.796 141.707,192.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "188.611,166.957 192.848,179.996 206.555,179.996 195.465,188.052 199.701,201.089  188.611,193.032 177.52,201.089 181.757,188.052 170.666,179.996 184.375,179.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "231.277,154.157 235.514,167.196 249.222,167.196 238.131,175.252 242.369,188.289  231.277,180.232 220.187,188.289 224.423,175.252 213.334,167.196 227.041,167.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "366.055,179.757 361.819,192.796 348.112,192.796 359.201,200.852 354.965,213.889  366.055,205.832 377.147,213.889 372.91,200.852 384,192.796 370.293,192.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "323.389,166.957 319.152,179.996 305.445,179.996 316.535,188.052 312.299,201.089  323.389,193.032 334.48,201.089 330.243,188.052 341.334,179.996 327.625,179.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "280.723,154.157 276.486,167.196 262.778,167.196 273.869,175.252 269.631,188.289  280.723,180.232 291.813,188.289 287.577,175.252 298.666,167.196 284.959,167.196  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M290.134,265.089L256,222.422l-17.066,8.534v17.066l-25.6,17.066h-17.066v22.048 c25.015,10.129,42.666,34.638,42.666,63.285l0,0H256v-17.066l17.066-17.066l17.066,17.066l17.067-17.066v-17.066l17.066-25.6 L290.134,265.089z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXk);
export default __webpack_public_path__ + "static/media/xk.3183a403db1145fccc144320651a4756.svg";
export { ForwardRef as ReactComponent };